function CookiePolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-3xl font-bold mb-8">Cookie Policy</h1>

        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-8">
          <p className="text-blue-700">
            This policy explains how we use cookies on our website.
          </p>
        </div>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">What are cookies?</h2>
          <p>
            Cookies are often known as browser cookies or tracking cookies. These cookies are small encrypted text files 
            stored in browser directories. Like other web servers, we also place these cookies on your device to collect 
            standard internet log information and visitor behavior information.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">How do we use cookies?</h2>
          <p className="mb-4">
            The main purpose of placing these cookies is to provide you better user experience on our website. 
            These cookies are used in the following ways:
          </p>
          <ul className="list-disc pl-6">
            <li>To keep you signed in</li>
            <li>To understand user behavior on how you use our website</li>
            <li>To keep track of user visits and activities</li>
            <li>To auto-fill login details when your re-visit website</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">What type of cookies do we use?</h2>
          <p className="mb-4">
            There are many types of cookies, however, our website uses mainly below cookies:
          </p>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold mb-2">Necessary cookies</h3>
              <p>
                These cookies are essential for the basic functions of the website or to provide the product, 
                service or content requested by you. Without these cookies, we will not be able to provide you 
                the products or services asked for.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Functionality cookies</h3>
              <p>
                These cookies enable the website to provide enhanced functionality and personalization. 
                These cookies are set to provide better services that we have added to our pages.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Advertising</h3>
              <p className="mb-2">
                The website uses this type of cookies to collect information about your visits to our website. Such as:
              </p>
              <ul className="list-disc pl-6">
                <li>Which pages did you visit?</li>
                <li>What content did you view?</li>
                <li>Which links did you click?</li>
                <li>And other information about your browser, IP address, device, location.</li>
              </ul>
              <p className="mt-2">These cookies are used for advertising purposes.</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Analytics cookies</h3>
              <p>
                These cookies are set through our site by our advertising partners. These cookies are used to build 
                a profile of your interests and show you relevant advertisements based on your visits. They do not 
                store personal data but store info of your browser and internet device. You can opt-out by not allowing 
                these cookies which will lead to less targeted advertising.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Third-party cookies</h3>
              <p>
                We use these cookies from third-party organizations to get insights about our website. These cookies 
                are set by websites that are not visited by you by adding third-party elements like plugins or ads 
                on their website. Third-party cookies also track users activities and save their browsing information 
                for targeting ads.
              </p>
            </div>
          </div>
        </section>

        <div className="mt-12 text-sm text-gray-600">
          Last updated: December 23, 2024
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy;
